'use client';
import { useContext } from 'react';
import { ValuationContext } from '../_components/_state/ValuationContext';
import { type ValuationContextType } from '../types';

export const useValuationContext = () => {
  return useContext<ValuationContextType>(ValuationContext);
};
